import type { VideoModelConfig } from '../../types';

/** 可灵 2.1（仅图生视频 support_t2v=false；首尾帧受 pro 专业模式联动，阶段二保留后端 source 机制） */
export const kling2_1: VideoModelConfig = {
  id: '01K1321KC75YYHAXQTW0RV83M5',
  displayName: '可灵 2.1',
  defaults: {
    resolution: '720P',
    duration: 5,
  },
  resolutionOptions: [
    { label: '720P', value: '720P' },
    { label: '1080P', value: '1080P' },
  ],
  duration: { mode: 'options', options: [5, 10] },
  capabilities: {
    imageToVideoOnly: true,
  },
  limits: {
    maxRefImages: 1,
  },
};
